import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { checkStatus,getMonthTHFromInt,setLoader } from '../../../util/util';
import Select from 'react-select';
import map from 'lodash/map';
import RCPagination from '../UserControl/Pagination/RCPagination';
import { AlertBar, AlertConfirm } from '../../Modals/AlertBar';
import ModalConfirmDelete from '../../Modals/ModalConfirmDelete';
import {withNamespaces } from 'react-i18next'
// import TarckSummary from '../TarckSummary/TarckSummary';
import { none } from 'ol/centerconstraint';
import $ from 'jquery';
import { TimePicker } from 'antd';
import 'antd/dist/antd.css';
import moment from 'moment';
import TrackingCradList from '../../components/Monitor/TrackingCradList/TrackingCradList';
import DateTimeRange from '../../components/UserControl/DateTimeRange/DateTimeRange';
import TextBoxMultiCarFilter from '../../components/UserControl/TextBoxMultiCarFilter/TextBoxMultiCarFilter';
import {Alert} from '../../Modals/AlertBar';
import ReactToExcel from 'react-html-table-to-excel';

import html2canvas from 'html2canvas';
import * as jsPDF from 'jspdf'
// import  './css/print.css';
//import  './css/print.css';
import ReactToPrint from "react-to-print";
// import html2pdf from "html2pdf.js";
//import html2pdf from "html2pdf.js";
//import canvasToImage from 'Canvas2Image '
//import Canvas2Image from 'canvas2image'

//import './libs/table-export/tableExport';
//import './libs/jsPDF/jspdf.min'
//import './libs/jsPDF-AutoTable/jspdf.plugin.autotable';

//import print,{convertToJPEG} from "./js/print"
const Canvas2Image = window.Canvas2Image;
// import PDFKit from 'pdfkitjs';

let startHistoryDate=null;
let endHistoryDate=null;
let tagsHistory=null;
let tagsDevice=[];
let tagsCarAlert=null;
let m_trackHistoryList=null;
let m_trackHistory2List=null;
let token //= getMainCookie().token;
let intervalAlert;
let m_carAlertNotify = false;

class ReportUsageSummary extends Component {

    constructor(props) {
		super(props);

        this.mapTracking = React.createRef();
        this.mapTrackingPoi = React.createRef();
        this.mapTrackingHistory = React.createRef();
        this.mapAlert = React.createRef();
        this.trackingCradListHistory = React.createRef();
        this.trackingCradList = React.createRef();
        this.carAlertList = React.createRef();

        // this.tmeHistoryStart =  React.createRef();
        // this.tmeHistoryEnd =  React.createRef();
        this.state  = {
            isShowTracking:true,
            isShowTrackCardList : false,
            isShowTrackingHistory:false,
            isShowTrackHistoryCardList : false,
            isShowGroupList:false,
            selectHistoryDateRange:{
                                    startDate:this.getCurrentDate(new Date()),
                                    endDate:this.getCurrentDate(new Date()),
                                    startTimeHistory:"00:00",
                                    endTimeHistory:"23:50"
                                    },
            isShowPOI:false,
            isShowMapAlert:false,
            carAlertList : [],
            lonlatByMark :[],
            selectPOIByMap : "",
            isClickLoadReport: '',
            deviceNoList:[],

            isClearable: true,
            isDisabled: false,
            isLoading: false,
            isRtl: false,
            isSearchable: true,

            deviceList:[],
            currentPage:1,
            currentPageSize:10,
            totalPage:0,

            checkAll: false,
            isMobile: false
        };
    }

    componentWillMount() {
        console.log('window.innerWidth:', window.innerWidth);
        this.setState({ isMobile: window.innerWidth < 400 });
    }

    componentDidMount(){
        console.log("MapTrackingHistory componentDidMount")
        $("#mapTrackingHistory").css("height", $(window).height() - 190);
        
        this.getActiveDeviceUserRelated();
    }
    componentWillUnmount(){
        console.log("MapTrackingHistory componentWillUnmount");
        // clearMapTrackingHistory();
        tagsDevice = []
        this.setState({
            deviceList:[],
            device_no1:"",
            device_no2:"",
        })
    }
    btnSearchHistoryClick = (e) => {

        if(e === undefined){
            return;
        }

        console.log("btnSearchHistoryClick",this.getCurrentDate( startHistoryDate),this.state.selectHistoryDateRange.startTimeHistory,this.state.selectHistoryDateRange.endTimeHistory,tagsDevice);
        if(startHistoryDate==null || endHistoryDate==null || this.state.selectHistoryDateRange.startTimeHistory==""  || this.state.selectHistoryDateRange.endTimeHistory=="")
            Alert("กรุณาใส่ข้อมูล","วัน เวลา ที่ต้องการดูย้อนหลัง");
        else{
            let stime = this.state.selectHistoryDateRange.startTimeHistory;
            let etime = this.state.selectHistoryDateRange.endTimeHistory;
            let start = this.getCurrentDate(startHistoryDate);
            let end = this.getCurrentDate(endHistoryDate)
            let dd=this.getCurrentDate(startHistoryDate).split("-")[0];
            let mm=this.getCurrentDate(startHistoryDate).split("-")[1];
            let yyyy=this.getCurrentDate(startHistoryDate).split("-")[2];
            start = dd + "-" + mm + "-" + yyyy;
            dd=this.getCurrentDate(endHistoryDate).split("-")[0];
            mm=this.getCurrentDate(endHistoryDate).split("-")[1];
            yyyy=this.getCurrentDate(endHistoryDate).split("-")[2];
            end = dd + "-" + mm + "-" + yyyy;


            // this.onPageSizeChange(stime,start,etime,end,tagsDevice,this.state.currentPage,this.state.currentPageSize);
            this.onPageSizeChange(this.state.currentPage,this.state.currentPageSize);
            // this.getReportSummaryByDevice(stime,start,etime,end,tagsDevice);
            // this.mapTrackingPoi.current.setMapTrackingHistory(stime,start,etime,end,tagsHistory);
            console.log(stime,start,etime,end,tagsDevice)
        }

    }

    getReport(){
        console.log('getreport',this.state.deviceList)
        const { user_id, user_name,token} = this.props;
        let date = `ระหว่างวันที่ ${this.getCurrentDate( startHistoryDate)+","+this.state.selectHistoryDateRange.startTimeHistory } ถึง ${this.getCurrentDate( endHistoryDate) +","+this.state.selectHistoryDateRange.endTimeHistory}`;
        setLoader(true);
        fetch(`http://203.150.199.244/api/report/exportPdf/01`, {
            method: 'post',
            headers: {
                "Content-Type": "application/json; charset=utf-8",
            //    "user_id": user_id,
            //    "user_name": user_name,
                "token": token

            },
            body: JSON.stringify({
                "title":date,
                "result_data": this.state.deviceList
            })
            })
            .then(response => { return checkStatus(response)})
            .then(data => {
                console.log(data)
                    // this.downloadPDF(data.file_name);
                    document.location.href = `http://203.150.199.244/api/report/download/${data.file_name}`;
            })
            .catch(function (err) {
                console.log('err:', err);
                // POST failed...
            });
            setLoader(false);
    }

    downloadPDF(fileName){

        console.log('fileName',fileName)
        const { user_id, user_name,token} = this.props;
        setLoader(true);
        fetch(`http://203.150.199.244/api/report/download/${fileName}`, {
            method: 'get',
            headers: {
                "Content-Type": "pdf",
            //    "user_id": user_id,
            //    "user_name": user_name,
                "token": token
            }
            })
            .then(response => { return checkStatus(response)})
            .then(data => {
                
                    // this.downloadPDF(data.fileName);
            })
            .catch(function (err) {
                console.log('err:', err);
                // POST failed...
            });
            setLoader(false);
    }

    getCurrentDate(today){
        //let today = new Date();
        if(today==null)
            return null;
        let dd = !today.date?today.getDate():today.date;
        let mm = today.months==undefined?today.getMonth()+1:today.months+1; //January is 0! today
        let yyyy = !today.years?today.getFullYear():today.years;
        if(dd<10) {
            dd = '0'+dd
        }
        if(mm<10) {
            mm = '0'+mm
        }
        return( dd + '-' +  mm+ '-' + yyyy);
    }

    handleStartTimeHistoryChange(value){
        this.state.selectHistoryDateRange.startTimeHistory = value.format('HH')+":"+value.format('mm');
    }
    handleEndTimeHistoryChange(value){
        this.state.selectHistoryDateRange.endTimeHistory = value.format('HH')+":"+value.format('mm');
    }
    setRangeDate(sDate,eDate){
        startHistoryDate=sDate;
        endHistoryDate=eDate;
        if(sDate && eDate && sDate!=null && eDate!=null){
            startHistoryDate=sDate.toObject();
            endHistoryDate=eDate.toObject();
        }
        console.log("setRangeDate",startHistoryDate,endHistoryDate);
    }

    handleClick = () => {

        this.btnSearchHistoryClick();
        const { isClickLoadReport } = this.state;
        console.log('isClickLoadReportXXXX:', isClickLoadReport);
        if (isClickLoadReport === 'show') {
            this.setState({isClickLoadReport: ''});
        } else {
            this.setState({isClickLoadReport: 'show'});
        }
    }

    setMultiCar(tags){
        tagsDevice = tags;
        console.log("tag",tagsDevice);
        // if(this.state.isShowTracking && this.mapTrackingPoi.current != null)
        //     this.mapTrackingPoi.current.searchCarTrack(tags,this.state.isShowGroupList);
    }

    getActiveDeviceUserRelated(){

        const { user_id, user_name,token} = this.props;
        console.log('tokenPOI',token)
        fetch(`http://203.150.199.244/api/admin/getActiveDeviceUserRelated/99999`, {
            method: 'post',
            headers: {
                "Content-Type": "application/json; charset=utf-8",
            //    "user_id": user_id,
            //    "user_name": user_name,
                "token": token

            },
            body: JSON.stringify({
            })
            })
            .then(response => { return checkStatus(response)})
            .then(data => {
                this.setState({
                    deviceNoList:data.RESULT_DATA,
                })

            })
            .catch(function (err) {
                console.log('err:', err);
                // POST failed...
            });
    }

    getReportSummaryByDevice(stime,start,etime,end,tagsDevice){


        let start_date = start+" "+stime;
        let end_date = end+" "+etime;
        const { user_id, user_name,token} = this.props;
        fetch(`http://203.150.199.244/api/report/getReportSummaryByDevice/${this.state.currentPage}/${this.state.currentPageSize}`, {
            method: 'post',
            headers: {
                "Content-Type": "application/json; charset=utf-8",
            //    "user_id": user_id,
            //    "user_name": user_name,
                "token": token

            },
            body: JSON.stringify({
                "devices":tagsDevice,
                "start_date" : start_date,
                "end_date": end_date
            })
            })
            .then(response => { return checkStatus(response)})
            .then(data => {
                console.log('report device',data)
                this.setState({
                    deviceList:data.RESULT_DATA,
                    totalPage:data.RESULT_TOTAL,
                    currentPage:this.state.currentPage,
                    currentPageSize:this.state.currentPageSize
                })

            })
            .catch(function (err) {
                console.log('err:', err);
                // POST failed...
            });
    }

    handleCheckboxChange(event) {
        const target = event.target;
        const value = target.type === 'checkbox' ? target.checked : target.value;
        const name = target.name;


        this.setState({
          [name]: value
        });



        this.state.deviceList.map((d) => {

            // console.log("#checkId"+d.device_id)
            // $("#"+d.device_id).checked;
            let aaa = "checkId"+d.device_id;
            var object = this.refs[`${aaa}`];
            object.checked = value;
            console.log(object,d)

        })
      }

      onChangeDeviceCheck(event){

        let object = this.refs.checkAll;
        object.checked = false;

        const target = event.target;
        const value = target.type === 'checkbox' ? target.checked : target.value;
        const name = target.name;
        console.log(name,value)
      }

      onPageSelect(page){

       const { currentPageSize } = this.state;
       const { user_id, user_name,token} = this.props;

        let stime = this.state.selectHistoryDateRange.startTimeHistory;
        let etime = this.state.selectHistoryDateRange.endTimeHistory;
        let start = this.getCurrentDate(startHistoryDate);
        let end = this.getCurrentDate(endHistoryDate)
        let dd=this.getCurrentDate(startHistoryDate).split("-")[0];
        let mm=this.getCurrentDate(startHistoryDate).split("-")[1];
        let yyyy=this.getCurrentDate(startHistoryDate).split("-")[2];
        start = dd + "-" + mm + "-" + yyyy;
        dd=this.getCurrentDate(endHistoryDate).split("-")[0];
        mm=this.getCurrentDate(endHistoryDate).split("-")[1];
        yyyy=this.getCurrentDate(endHistoryDate).split("-")[2];
        end = dd + "-" + mm + "-" + yyyy;

       let start_date = start+" "+stime;
       let end_date = end+" "+etime;
       fetch(`http://203.150.199.244/api/report/getReportSummaryByDevice/${page}/${currentPageSize}`, {
           method: 'post',
           headers: {
               "Content-Type": "application/json; charset=utf-8",
            //    "user_id": user_id,
            //    "user_name": user_name,
               "token": token
           },
           body: JSON.stringify({
            "devices":tagsDevice,
            "start_date" : start_date,
            "end_date": end_date
           })
           })
           .then(response => { return checkStatus(response)})
           .then(data => {
               console.log('nextpage',data)
               this.setState({
                deviceList:data.RESULT_DATA,
                   totalPage:data.RESULT_TOTAL,
                   currentPage:page,currentPageSize:currentPageSize})

           })
           .catch(function (err) {
               console.log('err:', err);
               // POST failed...
           });
   
    }

    //   onPageSelect(stime,start,etime,end,tagsDevice,page){

    //     let start_date = start+" "+stime;
    //     let end_date = end+" "+etime;
    //     const { currentPageSize } = this.state;
    //     const { user_id, user_name,token} = this.props;
    //     fetch(`http://203.150.199.244/api/admin/getDeviceList/${page}/${currentPageSize}`, {
    //         method: 'post',
    //         headers: {
    //             "Content-Type": "application/json; charset=utf-8",
    //             // "user_id": user_id,
    //             // "user_name": user_name,
    //             "token": token
    //         },
    //         body: JSON.stringify({
    //             "devices":tagsDevice,
    //             "start_date" : start_date,
    //             "end_date": end_date
    //         })
    //         })
    //         .then(response => { return checkStatus(response)})
    //         .then(data => {
    //             this.setState({
    //                 deviceList:data.RESULT_DATA,
    //                 totalPage:data.RESULT_TOTAL,
    //                 currentPage:page,currentPageSize:currentPageSize})

    //         })
    //         .catch(function (err) {
    //             console.log('err:', err);
    //             // POST failed...
    //         });
    // }

    getStartDate(){

        let stime = this.state.selectHistoryDateRange.startTimeHistory;
        let start = this.getCurrentDate(startHistoryDate);
        let dd=this.getCurrentDate(startHistoryDate).split("-")[0];
        let mm=this.getCurrentDate(startHistoryDate).split("-")[1];
        let yyyy=this.getCurrentDate(startHistoryDate).split("-")[2];
        start = dd + "-" + mm + "-" + yyyy;

       let start_date = start+" "+stime;
       return start_date;
    }
    getEndDate(){

        let etime = this.state.selectHistoryDateRange.endTimeHistory;
        let end = this.getCurrentDate(endHistoryDate)
        
        let dd=this.getCurrentDate(endHistoryDate).split("-")[0];
        let mm=this.getCurrentDate(endHistoryDate).split("-")[1];
        let yyyy=this.getCurrentDate(endHistoryDate).split("-")[2];
        end = dd + "-" + mm + "-" + yyyy;

       let end_date = end+" "+etime;
       return end_date;
    }

    // onPageSizeChange(stime,start,etime,end,tagsDevice,page, pageSize){
    onPageSizeChange(page, pageSize){

       let start_date = this.getStartDate();
       let end_date = this.getEndDate();
       console.log('start_date',start_date)
        console.log('end_date',end_date)
        console.log('tagsDevice',tagsDevice);
        
        if(tagsDevice.length > 0){
            setLoader(true);
            const { user_id, user_name,token} = this.props;
            fetch(`http://203.150.199.244/api/report/getReportSummaryByDevice/${page}/${pageSize}`, {
                method: 'post',
                headers: {
                    "Content-Type": "application/json; charset=utf-8",
                //    "user_id": user_id,
                //    "user_name": user_name,
                    "token": token
    
                },
                body: JSON.stringify({
                    "devices":tagsDevice,
                    "start_date" : start_date,
                    "end_date": end_date
                })
                })
                .then(response => { return checkStatus(response)})
                .then(data => {
                    // if(data && data.length > 0){
                        this.setState({
                            deviceList:data.RESULT_DATA,
                            totalPage:data.RESULT_TOTAL,
                            currentPage:page,
                            currentPageSize:pageSize
                        })
                    // }else{
                    //     this.setState({
                    //         deviceList:[],
                    //         totalPage:0,
                    //     })
                    // }
                    
                    setLoader(false);
                })
                .catch(function (err) {
                    console.log('err:', err);
                    // POST failed...
                    setLoader(false);
                });
        }else{
            console.log('else');
            
            this.setState({
                deviceList:null
            })
        }
        
            
        // let data=tmpdeviceList.slice((page-1)*pageSize,((page-1)*pageSize)+pageSize)
        // this.setState({deviceList:data,currentPage:page,currentPageSize:pageSize})
        // console.log('onPageSizeChange',data)
    }

    clickBack(){

        tagsDevice = []
        
        this.setState({
            deviceList:[],
            device_no1:"",
            device_no2:"",
        })

        this.props.onClickBackToReportPortal();
    }
    setFonSize(elm, fontsize){
        elm.style.fontSize = fontsize;
    }
    exportPDF(){

        this.getReport();
        // //$(".print-text-blod").show()

        // $(".print-text-blod").show()

        //  html2canvas(document.querySelector("#rpUseageSummary"), {
        //     scale:1.3
        //   }).then(canvas => {
        //     var imageData = canvas.toDataURL("image/png");
        //         var image = new Image();

        //         image.onload = function(){
        //             var doc = new jsPDF();
        //            // doc.addImage(imageData, 'PNG', 12, 10);
        //             var croppingYPosition = 0;
        //             let count = (canvas.height) / 1000;
        //             for (var i =0; i < count; i++) {
                           
        //                     var sourceX = 0;
        //                     var sourceY = croppingYPosition;
        //                     var sourceWidth = canvas.width;
        //                     var sourceHeight = 1050;
        //                     var destWidth = sourceWidth;
        //                     var destHeight = sourceHeight;
        //                     var destX = 0;
        //                     var destY = 0;
        //                     var canvas1 = document.createElement('canvas');
        //                     canvas1.setAttribute('height', destHeight);
        //                     canvas1.setAttribute('width', destWidth);
        //                     var ctx = canvas1.getContext("2d");


        //                      ctx.drawImage(image, sourceX,
        //                         sourceY,
        //                         sourceWidth,
        //                         sourceHeight,
        //                         destX,
        //                         destY,
        //                         destWidth,
        //                         destHeight);
        //                     var image2 = new Image();
        //                    image2 = Canvas2Image.convertToPNG(canvas1);
        //                     let image2Data = image2.src;
        //                     doc.addImage(image2Data, 'PNG', 12, 10);
        //                     croppingYPosition += destHeight;
        //                     if(i+1<count)
        //                         doc.addPage();
        //                 }
        //             var d = new Date().toISOString().slice(0, 19).replace(/-/g, "");
        //             let filename = 'report_' + d + '.pdf';
        //             doc.save(filename);
        //             $(".print-text-blod").hide()
        //           };
        //        image.src = Canvas2Image.convertToPNG(canvas).src;


        // });



    }

    reportCard(list){
        // if(list != null && list.length > 0){
        console.log('xxxxxxxxxxxx',list)

        let rowsPrint =[];
        let rowsDisplay =[];

        let rowsPrintExcel =[];

        list.map((device) => {

            rowsDisplay.push(
                <div>
                <div className="card" >
                     <div className="card-header">
                         <h4>
                             {/* <input type="checkbox" id={"checkId"+device.device_id} name={"checkId"+device.device_id} ref={"checkId"+device.device_id} onChange={(e) => {this.onChangeDeviceCheck(e)}} />&nbsp; */}
                             <i className="fa fa-ticket fa-lg" aria-hidden="true" style={{color:'red'}} ></i>
                         <strong> {device.device_no}</strong>
                         </h4>
                     </div>
                     <div className="card-body">
                         <h5 className="card-title"><i className="fa fa-fw fa-lg fa-code-fork " style={{color:'green'}}
                        aria-hidden="true"></i><strong>การเดินทาง</strong></h5>

                        <div className="row">
                            <div className="col-md-6" style={{width:500}}>
                            <form>
                                <div className="form-group row">
                                    <strong  className="col-md-4  col-form-label text-right" >ระยะเวลาที่วิ่งนานที่สุด</strong>
                                    <div className="col-md-8">
                                        <label className=" col-form-label ">  {device.moving.max_period}</label>
                                    </div>
                                </div>
                                <div className="form-group row">
                                    <strong  className="col-md-4  col-form-label text-right" >ระยะทางที่วิ่งนานที่สุด</strong>
                                    <div className="col-md-8">
                                        <label className=" col-form-label "> {device.moving.max_period_distance }</label>
                                    </div>
                                </div>
                                <div className="form-group row">
                                    <strong  className="col-md-4  col-form-label text-right" >รวมระยะเวลาที่ใช้</strong>
                                    <div className="col-md-8">
                                        <label className=" col-form-label "> {device.moving.total_elapse_times}</label>
                                    </div>
                                </div>
                                </form>
                            </div>
                            <div className="col-md-6">
                                <form>
                                <div className="form-group row">
                                    <strong  className="col-md-4  col-form-label text-right" >เมื่อเวลา</strong>
                                    <div className="col-md-8">
                                        <label className=" col-form-label "> {device.moving.max_period_dtm}</label>
                                    </div>
                                </div>
                                <div className="form-group row">
                                    <strong  className="col-md-4  col-form-label text-right" >รวมระยะทาง</strong>
                                    <div className="col-md-8">
                                        <label className=" col-form-label "> {device.moving.total_distance}</label>
                                    </div>
                                </div>
                                </form>
                            </div>
                        </div>

                        <hr/>

                        <h5 className="card-title"><i className="fa fa-fw fa-lg fa-code-fork " style={{color:'green'}}
                        aria-hidden="true"></i><strong>ความเร็วเกินกำหนด</strong></h5>

                        <div className="row">
                            <div className="col-md-6">
                            <form>
                                <div className="form-group row">
                                    <strong  className="col-md-4  col-form-label text-right" >ระยะเวลาเร็วเกินนานสุด</strong>
                                    <div className="col-md-8">
                                        <label className=" col-form-label ">  {device.speed_over.max_period}</label>
                                    </div>
                                </div>
                                <div className="form-group row">
                                    <strong  className="col-md-4  col-form-label text-right" >ความเร็วสูงสุด</strong>
                                    <div className="col-md-8">
                                        <label className=" col-form-label "> {device.speed_over.max_speed}</label>
                                    </div>
                                </div>
                                <div className="form-group row">
                                    <strong  className="col-md-4  col-form-label text-right" >รวมระยะเวลาที่ใช้</strong>
                                    <div className="col-md-8">
                                        <label className=" col-form-label "> {device.speed_over.total_elapse_times}</label>
                                    </div>
                                </div>
                                <div className="form-group row">
                                    <strong  className="col-md-4  col-form-label text-right" >จำนวนครั้งที่วิ่งเร็ว</strong>
                                    <div className="col-md-8">
                                        <label className=" col-form-label "> {device.speed_over.times}</label>
                                    </div>
                                </div>
                                </form>
                            </div>
                            <div className="col-md-6">
                                <form>
                                <div className="form-group row">
                                    <strong  className="col-md-4  col-form-label text-right" >เมื่อเวลา</strong>
                                    <div className="col-md-8">
                                        <label className=" col-form-label "> {device.speed_over.max_period_dtm}</label>
                                    </div>
                                </div>
                                <div className="form-group row">
                                    <strong  className="col-md-4  col-form-label text-right" >เมื่อเวลา</strong>
                                    <div className="col-md-8">
                                        <label className=" col-form-label "> {device.speed_over.max_speed_dtm}</label>
                                    </div>
                                </div>
                                <div className="form-group row">
                                    <strong  className="col-md-4  col-form-label text-right" >รวมระยะทาง</strong>
                                    <div className="col-md-8">
                                        <label className=" col-form-label "> {device.speed_over.total_distance}</label>
                                    </div>
                                </div>
                                </form>
                            </div>
                        </div>

                        <hr/>

                        <h5 className="card-title"><i class="fa fa-fw fa-lg fa-dashboard" aria-hidden="true" style={{color:'blue'}} ></i><strong>จอดขณะติดเครื่องยนต์</strong></h5>
                        <div className="row">
                            <div className="col-md-6">
                            <form>
                                <div className="form-group row">
                                    <strong  className="col-md-4  col-form-label text-right" >ระยะเวลาจอดนานที่สุด</strong>
                                    <div className="col-md-8">
                                        <label className=" col-form-label "> {device.stop_machine_on.max_period}</label>
                                    </div>
                                </div>
                                <div className="form-group row">
                                    <strong  className="col-md-4  col-form-label text-right" >รวมระยะเวลาที่ใช้</strong>
                                    <div className="col-md-8">
                                        <label className=" col-form-label "> {device.stop_machine_on.total_elapse_times}</label>
                                    </div>
                                </div>
                            </form>
                            </div>
                            <div className="col-md-6">
                                <form>

                                <div className="form-group row">
                                    <strong  className="col-md-4  col-form-label text-right" >เมื่อเวลา</strong>
                                    <div className="col-md-8">
                                        <label className=" col-form-label "> {device.stop_machine_on.max_period_dtm}</label>
                                    </div>
                                </div>
                                </form>
                            </div>
                        </div>

                        <hr/>

                        <h5 class="card-title"><i class="fa fa-fw fa-lg fa-power-off " style={{color:'red'}} aria-hidden="true" ></i><strong>จอดขณะดับเครื่องยนต์</strong></h5>
                        <div className="row">
                            <div className="col-md-6">
                            <form>
                                <div className="form-group row">
                                    <strong  className="col-md-4  col-form-label text-right" >ระยะเวลาจอดนานที่สุด</strong>
                                    <div className="col-md-8">
                                        <label className=" col-form-label "> {device.stop_machine_off.max_period}</label>
                                    </div>
                                </div>
                                <div className="form-group row">
                                    <strong  className="col-md-4  col-form-label text-right" >รวมระยะเวลาที่ใช้</strong>
                                    <div className="col-md-8">
                                        <label className=" col-form-label "> {device.stop_machine_off.total_elapse_times}</label>
                                    </div>
                                </div>
                            </form>
                            </div>
                            <div className="col-md-6">
                                <form>

                                <div className="form-group row">
                                    <strong  className="col-md-4  col-form-label text-right" >เมื่อเวลา</strong>
                                    <div className="col-md-8">
                                        <label className=" col-form-label "> {device.stop_machine_off.max_period_dtm}</label>
                                    </div>
                                </div>
                                </form>
                            </div>
                        </div>

                        <hr/>

                        <h5 class="card-title"><i class="fa fa-fw fa-lg fa-rss" style={{color:'grey'}} aria-hidden="true" ></i><strong>ไม่มีสัญญาณ GPS</strong></h5>
                        <div className="row">
                            <div className="col-md-6">
                            <form>
                                <div className="form-group row">
                                    <strong  className="col-md-4  col-form-label text-right" >ระยะเวลาจอดนานที่สุด</strong>
                                    <div className="col-md-8">
                                        <label className=" col-form-label "> {device.no_gps.max_period}</label>
                                    </div>
                                </div>
                                <div className="form-group row">
                                    <strong  className="col-md-4  col-form-label text-right" >รวมระยะเวลาที่ใช้</strong>
                                    <div className="col-md-8">
                                        <label className=" col-form-label "> {device.no_gps.total_elapse_times}</label>
                                    </div>
                                </div>
                            </form>
                            </div>
                            <div className="col-md-6">
                                <form>
                                <div className="form-group row">
                                    <strong  className="col-md-4  col-form-label text-right" >เมื่อเวลา</strong>
                                    <div className="col-md-8">
                                        <label className=" col-form-label "> {device.no_gps.max_period_dtm}</label>
                                    </div>
                                </div>
                                </form>
                            </div>
                        </div>

                        <hr/>

                        <h5 class="card-title"><i class="fa fa-fw fa-lg fa-car" style={{color:'orange'}} aria-hidden="true" ></i><strong>ระยะเวลาติดเครื่อง</strong></h5>
                        <div className="row">
                            <div className="col-md-6">
                            <form>
                                <div className="form-group row">
                                    <strong  className="col-md-4  col-form-label text-right" >ระยะเวลาจอดนานที่สุด</strong>
                                    <div className="col-md-8">
                                        <label className=" col-form-label "> {device.machine_on.max_period}</label>
                                    </div>
                                </div>
                                <div className="form-group row">
                                    <strong  className="col-md-4  col-form-label text-right" >รวมระยะเวลาที่ใช้</strong>
                                    <div className="col-md-8">
                                        <label className=" col-form-label "> {device.machine_on.total_elapse_times}</label>
                                    </div>
                                </div>
                            </form>
                            </div>
                            <div className="col-md-6">
                                <form>
                                <div className="form-group row">
                                    <strong  className="col-md-4  col-form-label text-right" >เมื่อเวลา</strong>
                                    <div className="col-md-8">
                                        <label className=" col-form-label "> {device.machine_on.max_period_dtm}</label>
                                    </div>
                                </div>
                                </form>
                            </div>
                        </div>

                    </div>

                </div>
                 <br />
              </div>
            )
        })
            list.map((device) => {

                rowsPrint.push(
                   <tbody>
                       
                        <tr>
                            <td colSpan={4}>
                                <h6>
                                    <i className="fa fa-ticket fa-lg" aria-hidden="true" style={{color:'red'}} ></i>
                                    {device.device_no}
                                </h6>
                            </td>
                        </tr>
                        {/* การเดินทาง */}
                        <tr>
                            <td colSpan={4}>
                                <h6><i className="fa fa-fw fa-lg fa-code-fork " style={{color:'green'}}
                                aria-hidden="true"></i>การเดินทาง</h6>
                                <hr/>
                            </td>
                        </tr>
                        <tr>
                            <td >
                                <h6 > ระยะเวลาที่วิ่งนานที่สุด</h6>
                            </td>
                            <td >
                                {device.moving.max_period}
                            </td>
                            <td>
                                <h6> เมื่อเวลา</h6>
                            </td>
                            <td  style={{width:200}}>
                                {device.moving.max_period_dtm}
                            </td>
                        </tr>
                        <tr>
                            <td>
                                <h6> ระยะทางที่วิ่งนานที่สุด</h6>
                            </td>
                            <td>
                                {device.moving.max_period_distance }
                            </td>
                            <td>
                                <h6> รวมระยะทาง</h6>
                            </td>
                            <td>
                                {device.moving.total_distance}
                            </td>
                        </tr>
                        <tr>
                            <td>
                                <h6> รวมระยะเวลาที่ใช้</h6>
                            </td>
                            <td>
                                {device.moving.total_elapse_times}
                            </td>
                            <td>

                            </td>
                            <td>

                            </td>
                        </tr>
                        <tr>
                            <td colSpan={4}>
                                <hr/>
                            </td>
                        </tr>

                        {/* ความเร็วเกินกำหนด */}
                        <tr>
                            <td colSpan={4}>
                                <h6><i className="fa fa-fw fa-lg fa-code-fork " style={{color:'green'}}
                                aria-hidden="true"></i>ความเร็วเกินกำหนด</h6>
                                <hr/>
                            </td>
                        </tr>
                        <tr>
                            <td style={{width:200}}>
                                <h6 > ระยะเวลาเร็วเกินนานสุด</h6>
                            </td>
                            <td>
                                {device.speed_over.max_period}
                            </td>
                            <td style={{width:200}}> 
                                <h6> เมื่อเวลา</h6>
                            </td>
                            <td>
                                {device.speed_over.max_period_dtm}
                            </td>
                            <td style={{width:200}}> 
                                <h6> จำนวนครั้งที่วิ่งเร็ว</h6>
                            </td>
                            <td>
                                {device.speed_over.times}
                            </td>
                            
                        </tr>
                        <tr>
                           
                            <td >
                                <h6> ความเร็วสูงสุด</h6>
                            </td>
                            <td>
                                {device.speed_over.max_speed}
                            </td>
                            <td>
                                <h6> เมื่อเวลา</h6>
                            </td>
                            <td>
                                {device.speed_over.max_speed_dtm}
                            </td>
                            
                        </tr>
                        <tr>

                            <td>
                                <h6> รวมระยะเวลาที่ใช้</h6>
                            </td>
                            <td>
                                {device.speed_over.total_elapse_times}
                            </td>
                            <td>
                                <h6> รวมระยะทาง</h6>
                            </td>
                            <td>
                                {device.speed_over.total_distance}
                            </td>
                        </tr>
                        <tr>
                            <td colSpan={4}>
                                <hr/>
                            </td>
                        </tr>

                        {/* จอดขณะติดเครื่องยนต์ */}
                        <tr>
                            <td colSpan={4}>
                                <h6><i className="fa fa-fw fa-lg fa-code-fork " style={{color:'green'}}
                                aria-hidden="true"></i>จอดขณะติดเครื่องยนต์</h6>
                                <hr/>
                            </td>
                        </tr>
                        <tr>
                            <td style={{width:200}}>
                                <h6 > ระยะเวลาจอดนานที่สุด</h6>
                            </td>
                            <td>
                                {device.stop_machine_on.max_period}
                            </td>
                            <td style={{width:200}}> 
                                <h6> เมื่อเวลา</h6>
                            </td>
                            <td>
                                {device.stop_machine_on.max_period_dtm}
                            </td>
                            
                        </tr>
                        <tr>
                           
                            <td >
                                <h6> รวมระยะเวลาที่ใช้</h6>
                            </td>
                            <td>
                                {device.stop_machine_on.total_elapse_times}
                            </td>
                            <td>
                                
                            </td>
                            <td>
                                
                            </td>
                        </tr>
                        <tr>
                            <td colSpan={4}>
                                <hr/>
                            </td>
                        </tr>

                        {/* จอดขณะดับเครื่องยนต์ */}
                        <tr>
                            <td colSpan={4}>
                                <h6><i className="fa fa-fw fa-lg fa-code-fork " style={{color:'green'}}
                                aria-hidden="true"></i>จอดขณะดับเครื่องยนต์</h6>
                                <hr/>
                            </td>
                        </tr>
                        <tr>
                            <td style={{width:200}}>
                                <h6 > ระยะเวลาจอดนานที่สุด</h6>
                            </td>
                            <td>
                                {device.stop_machine_on.max_period}
                            </td>
                            <td style={{width:200}}> 
                                <h6> เมื่อเวลา</h6>
                            </td>
                            <td>
                                {device.stop_machine_on.max_period_dtm}
                            </td>
                            
                        </tr>
                        <tr>
                           
                            <td >
                                <h6> รวมระยะเวลาที่ใช้</h6>
                            </td>
                            <td>
                                {device.stop_machine_on.total_elapse_times}
                            </td>
                            <td>
                                
                            </td>
                            <td>
                                
                            </td>
                        </tr>
                        <tr>
                            <td colSpan={4}>
                                <hr/>
                            </td>
                        </tr>

                        {/* ไม่มีสัญญาณ GPS */}
                        <tr>
                            <td colSpan={4}>
                                <h6><i className="fa fa-fw fa-lg fa-code-fork " style={{color:'green'}}
                                aria-hidden="true"></i>ไม่มีสัญญาณ GPS</h6>
                                <hr/>
                            </td>
                        </tr>
                        <tr>
                            <td style={{width:200}}>
                                <h6 > ระยะเวลาจอดนานที่สุด</h6>
                            </td>
                            <td>
                                {device.no_gps.max_period}
                            </td>
                            <td style={{width:200}}> 
                                <h6> เมื่อเวลา</h6>
                            </td>
                            <td>
                                {device.no_gps.max_period_dtm}
                            </td>
                            
                        </tr>
                        <tr>
                           
                            <td >
                                <h6> รวมระยะเวลาที่ใช้</h6>
                            </td>
                            <td>
                                {device.no_gps.total_elapse_times}
                            </td>
                            <td>
                                
                            </td>
                            <td>
                                
                            </td>
                        </tr>
                        <tr>
                            <td colSpan={4}>
                                <hr/>
                            </td>
                        </tr>

                        {/* ระยะเวลาติดเครื่อง */}
                        <tr>
                            <td colSpan={4}>
                                <h6><i className="fa fa-fw fa-lg fa-code-fork " style={{color:'green'}}
                                aria-hidden="true"></i>ระยะเวลาติดเครื่อง</h6>
                                <hr/>
                            </td>
                        </tr>
                        <tr>
                            <td style={{width:200}}>
                                <h6 > ระยะเวลาจอดนานที่สุด</h6>
                            </td>
                            <td>
                                {device.machine_on.max_period}
                            </td>
                            <td style={{width:100}}> 
                                <h6> เมื่อเวลา</h6>
                            </td>
                            <td>
                                {device.machine_on.max_period_dtm}
                            </td>
                            
                        </tr>
                        <tr>
                           
                            <td >
                                <h6> รวมระยะเวลาที่ใช้</h6>
                            </td>
                            <td>
                                {device.machine_on.total_elapse_times}
                            </td>
                            <td>
                                
                            </td>
                            <td>
                                
                            </td>
                        </tr>
                        <tr>
                            <td colSpan={4}>
                                <hr/>
                            </td>
                        </tr>
                </tbody>



                )
            })

            list.map((device) => {
                console.log('XXXXXXXXXXXXx',device)
                rowsPrintExcel.push(
                    
                   <tbody>

                        <tr>
                        </tr>
                        <tr>
                            <td>
                                
                                <table border="1">
                                <tbody>
                                    <tr>
                                        <td colSpan={7} >
                                            <h3>
                                                
                                               {"ทะเบียน: "+device.device_no}
                                            </h3>
                                        </td>
                                    </tr>
                                    <tr>
                                        <td colSpan={7}>
                                            <h4>การเดินทาง</h4>
                                        </td>
                                    </tr>
                                    <tr>
                                        <td colSpan={2}>
                                            <h4 > ระยะเวลาที่วิ่งนานที่สุด</h4>
                                        </td>
                                        <td >
                                            {device.moving.max_period}
                                        </td>
                                        <td>
                                            <h4> เมื่อเวลา</h4>
                                        </td>
                                        <td colSpan={3}>
                                            {device.moving.max_period_dtm}
                                        </td>
                                    </tr>
                                    <tr>
                                        <td colSpan={2}>
                                            <h4> ระยะทางที่วิ่งนานที่สุด</h4>
                                        </td>
                                        <td>
                                            {device.moving.max_period_distance }
                                        </td>
                                        <td >
                                            <h4> รวมระยะทาง</h4>
                                        </td>
                                        <td  colSpan={3}>
                                            {device.moving.total_distance}
                                        </td>
                                    </tr>
                                    <tr>
                                        <td colSpan={2}>
                                            <h4> รวมระยะเวลาที่ใช้</h4>
                                        </td>
                                        <td>
                                            {device.moving.total_elapse_times}
                                        </td>
                                        <td>
                                            
                                        </td>
                                        <td colSpan={3}>
                                            
                                        </td>
                                    </tr>
                                    <tr>
                                    </tr>


                                    <tr >
                                        <td colSpan={7}>
                                            <h4>ความเร็วเกินกำหนด</h4>
                                        </td>
                                    </tr>
                                    <tr>
                                        <td colSpan={2}>
                                            <h4> ระยะเวลาเร็วเกินนานสุด</h4>
                                        </td>
                                        <td>
                                            {device.speed_over.max_period}
                                        </td>
                                        <td> 
                                            <h4> เมื่อเวลา</h4>
                                        </td>
                                        <td colSpan={3}>
                                            {device.speed_over.max_period_dtm}
                                        </td>
                                        
                                    </tr>
                                    
                                    <tr>
                                        <td colSpan={2}>
                                            <h4> ความเร็วสูงสุด</h4>
                                        </td>
                                        <td>
                                            {device.speed_over.max_speed}
                                        </td>
                                        <td>
                                            <h4> เมื่อเวลา</h4>
                                        </td>
                                        <td colSpan={3}>
                                            {device.speed_over.max_speed_dtm}
                                        </td>
                                        
                                    </tr>
                                    <tr>

                                        <td colSpan={2}>
                                            <h4> รวมระยะเวลาที่ใช้</h4>
                                        </td>
                                        <td>
                                            {device.speed_over.total_elapse_times}
                                        </td>
                                        <td>
                                            <h4> รวมระยะทาง</h4>
                                        </td>
                                        <td colSpan={3}>
                                            {device.speed_over.total_distance}
                                        </td>
                                    </tr>
                                    <tr>
                                        <td colSpan={2}> 
                                        <h4> จำนวนครั้งที่วิ่งเร็ว</h4>
                                        </td>
                                        <td>
                                            {device.speed_over.times}
                                        </td>
                                    </tr>

                                    <tr>
                                        <td colSpan={7}>
                                            <h4>จอดขณะติดเครื่องยนต์</h4>
                                        </td>
                                    </tr>
                                    <tr>
                                        <td colSpan={2}>
                                            <h4> ระยะเวลาจอดนานที่สุด</h4>
                                        </td>
                                        <td>
                                            {device.stop_machine_on.max_period}
                                        </td>
                                        <td> 
                                            <h4> เมื่อเวลา</h4>
                                        </td>
                                        <td colSpan={3}>
                                            {device.stop_machine_on.max_period_dtm}
                                        </td>
                                        
                                    </tr>
                                    <tr>
                                        
                                        <td colSpan={2}>
                                            <h4> รวมระยะเวลาที่ใช้</h4>
                                        </td>
                                        <td>
                                            {device.stop_machine_on.total_elapse_times}
                                        </td>
                                        <td>
                                            
                                        </td>
                                        <td colSpan={3}>
                                            
                                        </td>
                                    </tr>
                                    <tr>
                                    </tr>


                                    <tr>
                                        <td colSpan={7}>
                                            <h4>จอดขณะดับเครื่องยนต์</h4>
                                        </td>
                                    </tr>
                                    <tr>
                                        <td colSpan={2}>
                                            <h4> ระยะเวลาจอดนานที่สุด</h4>
                                        </td>
                                        <td>
                                            {device.stop_machine_on.max_period}
                                        </td>
                                        <td> 
                                            <h4> เมื่อเวลา</h4>
                                        </td>
                                        <td colSpan={3}>
                                            {device.stop_machine_on.max_period_dtm}
                                        </td>
                                        
                                    </tr>
                                    <tr>
                                    
                                        <td colSpan={2}>
                                            <h4> รวมระยะเวลาที่ใช้</h4>
                                        </td>
                                        <td>
                                            {device.stop_machine_on.total_elapse_times}
                                        </td>
                                        <td>
                                            
                                        </td>
                                        <td colSpan={3}>
                                            
                                        </td>
                                    </tr>
                                    <tr>
                                    </tr>

                                    <tr>
                                        <td colSpan={7}>
                                            <h4>ไม่มีสัญญาณ GPS</h4>
                                        </td>
                                    </tr>
                                    <tr>
                                        <td colSpan={2}>
                                            <h4> ระยะเวลาจอดนานที่สุด</h4>
                                        </td>
                                        <td>
                                            {device.no_gps.max_period}
                                        </td>
                                        <td> 
                                            <h4> เมื่อเวลา</h4>
                                        </td>
                                        <td colSpan={3}>
                                            {device.no_gps.max_period_dtm}
                                        </td>
                                        
                                    </tr>
                                    <tr>
                                    
                                        <td colSpan={2}>
                                            <h4> รวมระยะเวลาที่ใช้</h4>
                                        </td>
                                        <td>
                                            {device.no_gps.total_elapse_times}
                                        </td>
                                        <td>
                                            
                                        </td>
                                        <td colSpan={3}>
                                            
                                        </td>
                                    </tr>
                                    <tr>
                                    </tr>

                                    <tr>
                                        <td colSpan={7}>
                                            <h4>ระยะเวลาติดเครื่อง</h4>
                                        </td>
                                    </tr>
                                    <tr>
                                        <td colSpan={2}>
                                            <h4 > ระยะเวลาจอดนานที่สุด</h4>
                                        </td>
                                        <td>
                                            {device.machine_on.max_period}
                                        </td>
                                        <td > 
                                            <h4> เมื่อเวลา</h4>
                                        </td>
                                        <td colSpan={3}>
                                            {device.machine_on.max_period_dtm}
                                        </td>
                                        
                                    </tr>
                                    <tr>
                                    
                                        <td colSpan={2}>
                                            <h4> รวมระยะเวลาที่ใช้</h4>
                                        </td>
                                        <td>
                                            {device.machine_on.total_elapse_times}
                                        </td>
                                        <td>
                                            
                                        </td>
                                        <td colSpan={3}>
                                            
                                        </td>
                                    </tr>
                                    <tr>
                                    </tr>
                                    </tbody>
                                </table>
                            </td>
                        </tr>
                       
                </tbody>



                )
            })
                return(
                    <div>
                        <table  id="rpUseageSummary"  ref={el => (this.rpUseageSummary = el)} className="print-text-blod" style={{display:'none',width:550}}>
                        <tbody>
                            <tr>
                                <td colSpan={4}>
                                    <h6>
                                    สรุปการใช้งาน
                                    </h6>
                                </td>
                            </tr>
                            <tr>
                                <td colSpan={4}>
                                    <h6>
                                    {`ระหว่างวันที่ ${this.getCurrentDate( startHistoryDate)+","+this.state.selectHistoryDateRange.startTimeHistory } ถึง ${this.getCurrentDate( endHistoryDate) +","+this.state.selectHistoryDateRange.endTimeHistory}`}
                                    </h6>
                                    <hr/>
                                </td>
                            </tr>
                            {rowsPrint}
                            </tbody>
                        </table>

                        <table  id="rpUseageSummaryExcel" style={{display:'none'}}>
                        <tbody>
                            <tr >
                                <td colSpan={4}>
                                    <h3>
                                    สรุปการใช้งาน
                                    </h3>
                                </td>
                            </tr>
                            <tr>
                                <td colSpan={4}>
                                    <h4>
                                    {`ระหว่างวันที่ ${this.getCurrentDate( startHistoryDate)+","+this.state.selectHistoryDateRange.startTimeHistory } ถึง ${this.getCurrentDate( endHistoryDate) +","+this.state.selectHistoryDateRange.endTimeHistory}`}
                                    </h4>
                                    
                                </td>
                            </tr>
                            {rowsPrintExcel}
                            </tbody>
                        </table>


                        {rowsDisplay}
                    </div>
                    
            )
        // }
    }



    render(){
        
        const { onClickBackToReportPortal,t } = this.props;
        const { isClickLoadReport,currentPage,currentPageSize,totalPage,isMobile } = this.state;
console.log('pageeee',currentPage,currentPageSize,totalPage )
        const select=[];
        this.state.deviceNoList.map(device => {

            select.push({
                label:device.device_no,
                value:device.device_id,
            });
        });
        return(
            <div className="gray-panel" >
                    <h5 style={{ paddingLeft: '2em',cursor: 'pointer' }} onClick={onClickBackToReportPortal}>
                        <i
                            className="fa fa-arrow-left"
                            aria-hidden="true"
                            style={{ color: 'rgb(115, 134, 213)'}} />
                            <i className="fas fa-file-contract" style={{ color: '#7386D5', marginLeft:10,marginRight:5,cursor:"pointer" }} />รายงานข้อมูล
                    </h5>

                    <hr/>

                    <h5>
                        <span className="fa-stack fa-lg" style={{color: 'orange'}}>
                        <i className="fa fa-circle fa-stack-2x" />
                        <i className="fa fa-file-text-o fa-stack-1x" style={{color: 'white'}} />
                        </span>
                        สรุปการใช้งาน
                    </h5>

                    <hr />
                    <form name="searchfrom" className="form-inline">
                        <div className="row">

                            <div className='form-group'>

                                <i className="fas fa-shipping-fast icon-for-calendar" style={{fontSize:20,marginLeft:isMobile ? '0px' :'27px'}}/>
                                <TextBoxMultiCarFilter onChange={this.setMultiCar.bind(this)}/>
                                &nbsp;
                                {isMobile && <div className="form-group col-md-12">{'\n'}</div>} 
                                <label htmlFor="example-text-input" >{t('ระหว่างวันที่')}</label>&nbsp;
                                {isMobile && <div className="col-md-12">{'\n'}</div>} 
                                <TimePicker className="timeHistory" onChange={this.handleStartTimeHistoryChange.bind(this)} minuteStep={10} defaultValue={moment('00:00', 'HH:mm')} format={'HH:mm'} />&nbsp;
                                {isMobile && <div className="col-md-12">{'\n'}</div>}
                                <div className="input-group date" id="datetimepicker1">
                                    <DateTimeRange
                                            small={true}
                                            isBack
                                        startDateId="MyDatePicker"
                                        endDateId="your_unique_end_date_id"
                                        onSelectDate={this.setRangeDate.bind(this)}/>
                                </div>

                                <TimePicker className="timeHistory" onChange={this.handleEndTimeHistoryChange.bind(this)} minuteStep={10} defaultValue={moment('23:50', 'HH:mm')} format={'HH:mm'} />
                                &nbsp;
                                {isMobile && <div className="form-group col-md-12">{'\n'}</div>}
                                <div className="btn-group">
                                    {/* <input type="button" className="btn btn-primary btn-report" data-ext="html" onClick={(e) => this.btnSearchHistoryClick(e)} value="ตกลง" />
                                    <button type="button" name="dropdown-report" className="btn btn-primary dropdown-toggle" onClick={(e) => this.handleClick(e)}>
                                        <span className="caret" />
                                    </button> */}
                                    <button
                                        type="button"
                                        className="btn btn-primary btn-report"
                                        onClick={(e) => this.btnSearchHistoryClick(e)}
                                        data-ext="html">
                                        {'ตกลง'}
                                    </button>
                                    <button type="button" name="dropdown-report" className="btn btn-primary dropdown-toggle" onClick={(e) => this.handleClick(e)}>
                                        <span className="caret" />
                                    </button>
                                        <ul className={`dropdown-menu ${isClickLoadReport}`}>
                                            {/* <li onClick={() => this.setState({isClickLoadReport: '', reportType: 'pdf'})} className="item-text"><a><i className="fa fa-fw fa-file-pdf-o" style={{color: 'blue'}}/> รายงานแบบ PDF</a> */}
                                            <li onClick={() => this.getReport()} className="item-text">
                                                <button  className="btn btn-light">
                                                    <i className="fa fa-fw fa-file-pdf-o" style={{color: 'blue'}}/> 
                                                    &nbsp;&nbsp;&nbsp;รายงานแบบ PDF
                                                </button>
                                            </li>

                                            <li onClick={() => this.setState({isClickLoadReport: '' , reportType: 'excel'})} className="item-text">
                                                <button  className="btn btn-light">
                                                <i className="fa fa-fw fa-file-excel-o" style={{color: 'green'}}/>
                                                    <ReactToExcel
                                                        // style={{ borderStyle: '' }}
                                                        className="btn btn-light"
                                                        table="rpUseageSummaryExcel"
                                                        filename="summary"
                                                        sheet="sheet 1"
                                                        buttonText={"รายงานแบบ Excel"}
                                                    /> 
                                                </button>
                                            </li>
                                        </ul>
                                </div>

                                </div>
                            </div>
                    </form>
                            
                                <hr />

                                {
                                    this.state.deviceList != null && this.state.deviceList.length > 0 &&

                                    <div>
                                        {/* <div class="checkbox">
                                            <label>
                                            <input type="checkbox" class="check" id="checkAll" name="checkAll" ref="checkAll" checked={this.state.checkAll} onChange={(e) => this.handleCheckboxChange(e)} /> เลือกทั้งหมด
                                            </label>
                                        </div> */}

                                        {this.reportCard(this.state.deviceList)}

                                        <RCPagination
                                        onSelect={this.onPageSelect.bind(this)}
                                        onShowSizeChange={this.onPageSizeChange.bind(this)}
                                        total={totalPage}
                                        pageSize={this.state.currentPageSize}
                                        />

                                        <br/>
                                        <div className="push-up text-center ">
                                        <div class="btn-group" role="group" aria-label="Basic example">
                                            {/* <button  type="button" className="btn btn-light border border-secondary">
                                                <ReactToPrint
                                                    trigger={() => <a href="#">พิมพ์</a>}
                                                    content={() => this.rpUseageSummary}
                                                />
                                            </button> */}
                                                
                                                    
                                            <button onClick={() => this.getReport()} type="button" className="btn btn-light border border-secondary">
                                            <i className="fa fa-fw fa-file-pdf-o" style={{color: 'blue'}}/>
                                                รายงานแบบ PDF
                                                </button>
                                                

                                            <button type="button" className="btn btn-light border border-secondary">
                                                <i className="fa fa-fw fa-file-excel-o" style={{color: 'green'}} />
                                                    <ReactToExcel
                                                        style={{ borderStyle: '' }}
                                                        className="btn btn-light"
                                                        table="rpUseageSummaryExcel"
                                                        filename="summary"
                                                        sheet="sheet 1"
                                                        buttonText="รายงานแบบ Excel"
                                                    />
                                            </button>
                                            
                                        </div>
                                    </div>
                                    </div>


                                }

{
    this.state.deviceList == null &&

    <div style={{textAlign:'center'}}>
        -- ไม่มีข้อมูล --
    </div>
}                               

                                {/* <table id='table-to-excel'  className="table table-fixed no-margin table borderless" style={{fontSize: '14px', backgroundColor: 'white'}}>
                                    <div>{'สรุปการใช้งาน'}</div>
                                    <div>{`ระหว่างวันที่  ${this.getCurrentDate( startHistoryDate)+" , "+this.state.selectHistoryDateRange.startTimeHistory } ถึง ${this.getCurrentDate( endHistoryDate) +" , "+this.state.selectHistoryDateRange.endTimeHistory} `}</div>
                                    <thead border='1' >

                                    </thead>
                                    <tbody border='1'  style={{border: '4px solid black'}} className="text-left">
                                        <tr style={{border: '2px solid black'}}>
                                            <th colSpan={2}>การเดินทาง</th>
                                        </tr>
                                        <tr>

                                            <th width="400" style={{borderRight: '1px solid black'}}>ระยะเวลาที่วิ่งนานที่สุด</th>
                                            <td>xxx</td>
                                        </tr>
                                        <tr>
                                            <th width="400" style={{borderRight: '1px solid black'}}>ระยะทางที่วิ่งนานที่สุด</th>
                                            <td>xxx</td>
                                        </tr>
                                        <tr>
                                            <th scope="row" width="400" style={{borderRight: '1px solid black'}}>รวมระยะเวลาที่ใช้</th>
                                            <td>xxx</td>
                                        </tr>
                                        <tr>
                                            <th scope="row" width="400" style={{borderRight: '1px solid black'}}>เมื่อเวลา</th>
                                            <td>xxx</td>
                                        </tr>
                                        <tr>
                                            <th scope="row" width="400" style={{borderRight: '1px solid black'}}>รวมระยะทาง</th>
                                            <td>xxx</td>
                                        </tr>
                                    </tbody>
                                    <br/>
                                    <tbody style={{border: '4px solid black'}}>

                                        <tr style={{border: '2px solid black'}}>
                                            <th scope="row" colSpan={2}>ความเร็วเกินกำหนด</th>
                                        </tr>
                                        <tr>
                                            <th scope="row" width="400" style={{borderRight: '1px solid black'}}>ระยะเวลาเร็วเกินนานสุด</th>
                                            <td>xxx</td>
                                        </tr>
                                        <tr>
                                            <th scope="row" width="400" style={{borderRight: '1px solid black'}}>ความเร็วสูงสุด</th>
                                            <td>xxx</td>
                                        </tr>
                                        <tr>
                                            <th scope="row" width="400" style={{borderRight: '1px solid black'}}>รวมระยะเวลาที่ใช้</th>
                                            <td>xxx</td>
                                        </tr>
                                        <tr>
                                            <th scope="row" width="400" style={{borderRight: '1px solid black'}}>เมื่อเวลา</th>
                                            <td>xxx</td>
                                        </tr>
                                        <tr>
                                            <th scope="row" width="400" style={{borderRight: '1px solid black'}}>เมื่อเวลา</th>
                                            <td>xxx</td>
                                        </tr>
                                        <tr>
                                            <th scope="row" width="400" style={{borderRight: '1px solid black'}}>รวมระยะทาง</th>
                                            <td>xxx</td>
                                        </tr>
                                    </tbody>
                                    <br/>
                                    <tbody style={{border: '4px solid black'}}>

                                        <tr style={{border: '2px solid black'}}>
                                            <th scope="row" colSpan={2}>จอดขณะติดเครื่องยนต์</th>
                                        </tr>
                                        <tr>
                                            <th scope="row" width="400" style={{borderRight: '1px solid black'}}>ระยะเวลาจอดนานที่สุด</th>
                                            <td>xxx</td>
                                        </tr>
                                        <tr>
                                            <th scope="row" width="400" style={{borderRight: '1px solid black'}}>ความเร็วสูงสุด</th>
                                            <td>xxx</td>
                                        </tr>
                                        <tr>
                                            <th scope="row" width="400" style={{borderRight: '1px solid black'}}>รวมระยะเวลาที่ใช้</th>
                                            <td>xxx</td>
                                        </tr>

                                    </tbody>
                                    <br/>
                                    <tbody style={{border: '4px solid black'}}>

                                        <tr style={{border: '2px solid black'}}>
                                            <th scope="row" colSpan={2}>จอดขณะติดเครื่องยนต์</th>
                                        </tr>
                                        <tr>
                                            <th scope="row" width="400" style={{borderRight: '1px solid black'}}>ระยะเวลาจอดนานที่สุด</th>
                                            <td>xxx</td>
                                        </tr>
                                        <tr>
                                            <th scope="row" width="400" style={{borderRight: '1px solid black'}}>รวมระยะเวลาที่ใช้</th>
                                            <td>xxx</td>
                                        </tr>
                                        <tr>
                                            <th scope="row" width="400" style={{borderRight: '1px solid black'}}>เมื่อเวลา</th>
                                            <td>xxx</td>
                                        </tr>
                                    </tbody>
                                    <br/>
                                    <tbody style={{border: '4px solid black'}}>

                                        <tr style={{border: '2px solid black'}}>
                                            <th scope="row" colSpan={2}>จอดขณะดับเครื่องยนต์</th>
                                        </tr>
                                        <tr>
                                            <th scope="row" width="400" style={{borderRight: '1px solid black'}}>ระยะเวลาจอดนานที่สุด</th>
                                            <td>xxx</td>
                                        </tr>
                                        <tr>
                                            <th scope="row" width="400" style={{borderRight: '1px solid black'}}>รวมระยะเวลาที่ใช้</th>
                                            <td>xxx</td>
                                        </tr>
                                        <tr>
                                            <th scope="row" width="400" style={{borderRight: '1px solid black'}}>เมื่อเวลา</th>
                                            <td>xxx</td>
                                        </tr>
                                    </tbody>
                                    <br/>
                                    <tbody style={{border: '4px solid black'}}>

                                        <tr style={{border: '2px solid black'}}>
                                            <th scope="row" colSpan={2}>ไม่มีสัญญาณ GPS</th>
                                        </tr>
                                        <tr>
                                            <th scope="row" width="400" style={{borderRight: '1px solid black'}}>ระยะเวลาจอดนานที่สุด</th>
                                            <td>xxx</td>
                                        </tr>
                                        <tr>
                                            <th scope="row" width="400" style={{borderRight: '1px solid black'}}>รวมระยะเวลาที่ใช้</th>
                                            <td>xxx</td>
                                        </tr>
                                        <tr>
                                            <th scope="row" width="400" style={{borderRight: '1px solid black'}}>เมื่อเวลา</th>
                                            <td>xxx</td>
                                        </tr>
                                    </tbody>
                                    <br/>
                                    <tbody style={{border: '4px solid black'}}>

                                        <tr style={{border: '2px solid black'}}>
                                            <th scope="row" colSpan={2}>ระยะเวลาติดเครื่อง</th>
                                        </tr>
                                        <tr>
                                            <th scope="row" width="400" style={{borderRight: '1px solid black'}}>ระยะเวลาจอดนานที่สุด</th>
                                            <td>xxx</td>
                                        </tr>
                                        <tr>
                                            <th scope="row" width="400" style={{borderRight: '1px solid black'}}>รวมระยะเวลาที่ใช้</th>
                                            <td>xxx</td>
                                        </tr>
                                        <tr>
                                            <th scope="row" width="400" style={{borderRight: '1px solid black'}}>เมื่อเวลา</th>
                                            <td>xxx</td>
                                        </tr>
                                    </tbody>

                                </table>
                                <ReactToExcel
                                    style={{ borderStyle: '' }}
                                    className="btn-light"
                                    table="table-to-excel"
                                    filename="excelFile"
                                    sheet="sheet 1"
                                    buttonText="รายงานแบบ Excel"
                                /> */}



        </div>
        );
    }
}

ReportUsageSummary.propTypes = {
    t: PropTypes.func.isRequired,
    user_name: PropTypes.string.isRequired,
    user_id: PropTypes.number.isRequired,
    token: PropTypes.string.isRequired,
    onClickBackToReportPortal: PropTypes.func.isRequired
}

export default ReportUsageSummary;



// WEBPACK FOOTER //
// ./src/app/view/components/Report/ReportUsageSummary.js